import React, { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ReactGA from 'react-ga'
import './styles.scss'
import { addSubscription } from '../../../api/api'
import Loading from '../../../Components/loading/Loading'
import { Subscription } from '../../../types/plann3r'
import { CHARGEBEE_SITE } from '../../../constants'
import { IProps } from './types'
import { Plann3rStore } from '../../../store/types'

const Subscribe: FC<IProps> = () => {
  const [loading, setloading] = useState(false)
  const [cbInstance, setcbInstance] = useState()

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    setcbInstance(window.Chargebee.init({
      site: CHARGEBEE_SITE,
    }))
  }, [])

  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.subscribe,
  )

  const handleCheckout = (type: string) => {
    ReactGA.event({
      category: 'Subscribe',
      action: 'Clicked Button ' + type,
    })

    setloading(true)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    cbInstance.setPortalSession(function() {

      const result = addSubscription().then((response) => response)
      console.log(result, 'RESULT')
      return result
      // This should return a promise that resolves a portal session object.
      // If the library that you use for making ajax calls, can return a promise, 
      // you can directly return that.
      // We will discuss on how to implement this end point below.
      //return addSubscription().then((response) => response.portal_session)
    })

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const cbPortal = cbInstance.createChargebeePortal()
    cbPortal.open({
      close() {
        //close callbacks
      },
    })
    
    // cbInstance?.setPortalSession(addSubscription())

    // const portal = cbInstance?.createChargebeePortal()
    // portal.open({})
    // //if (cbInstance == undefined)
    //  return

    // const portal = cbInstance?.createChargebeePortal()
    // portal.open({
    // })
    // cbInstance.openCheckout({
    //   hostedPage: () => {
    //     return addSubscription().then((response) => response.hosted_page)
    //   },
    //   success() {
    //     ReactGA.event({
    //       category: 'Subscribe',
    //       action: 'Completed',
    //     })
    //     setTimeout(function() {
    //       window.location.reload()
    //       afterSubmit()
    //     }, 10000)
    //   },
    //   close: () => {
    //     ReactGA.event({
    //       category: 'Subscribe',
    //       action: 'Closed',
    //     })
    //     window.location.reload()
    //     setloading(false)
    //   },
    //   step() {
    //     //after();
    //   },
    // })
  }

  if (loading) {
    return (
      <div>
        <Loading />
      </div>
    )
  }
  return (
    <div className="subscribe">
      <div className="subscribe_top">
        <h2>{strings.upgrade_subscription}</h2>
        <h4>{strings.superpowers}</h4>
      </div>
      <div className="subscribe_content columns">
        <div className="pricingtype column is-6">
          <div className="top has-text-centered border-top-pink">
            <p className="has-text-centered is-caps">{strings.plus}</p>
            <h3>{strings.plus_price}</h3>
          </div>
          <div className="middle">
            <ul className="has-text-centered">
              <li>{strings.one_meeting_page}</li>
              <li>{strings.link_multiple}</li>
              <li>{strings.unlimited_integrations}</li>
            </ul>
          </div>
          <div className="bottom has-text-centered">
            <button
              className="button is-pink"
              onClick={() => {
                handleCheckout(Subscription.PLUS)
              }}
            >
              {strings.start_trial}
            </button>
          </div>
        </div>
        <div className="pricingtype column is-6">
          <div className="top has-text-centered border-top-blue">
            <p className="has-text-centered is-caps">{strings.professional}</p>
            <h3>{strings.professional_price_monthly}</h3>
            <span>{strings.or}</span>
            <h4>{strings.professional_price_yearly}</h4>
          </div>
          <div className="middle">
            <ul className="has-text-centered">
              <li>{strings.multiple_pages}</li>
              <li>{strings.multiple_persons}</li>
              <li>{strings.integrations}</li>
              <li>{strings.multiple_companies}</li>
              <li>{strings.support}</li>
            </ul>
          </div>
          <div className="bottom has-text-centered">
            <button
              className="button is-blue"
              onClick={() => {
                handleCheckout(Subscription.PROFESSIONAL)
              }}
            >
              {strings.trial_monthly}
            </button>
            <button
              className="button is-blue"
              onClick={() => {
                handleCheckout(Subscription.PROFESSIONAL_YEARLY)
              }}
            >
              {strings.trial_yearly}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Subscribe
